<template>
  <VaNavbar class="app-layout-navbar py-2 px-0" style="background-color: #0a2540; color: #ffffff">
    <template #left>
      <div class="left">
        <VaIconMenuCollapsed
          class="cursor-pointer MenuCollapsed"
          :class="{ 'x-flip': !isSidebarMinimized }"
          :color="collapseIconColor"
          @click="isSidebarMinimized = !isSidebarMinimized"
        />
        <Transition v-if="isMobile" name="icon-fade" mode="out-in">
          <VaIcon
            color="primary"
            :name="isSidebarMinimized ? 'menu' : 'close'"
            size="24px"
            style="margin-top: 3px"
            @click="isSidebarMinimized = !isSidebarMinimized"
          />
        </Transition>
        <IntmainLogo :width="isMobile ? '100%' : '160px'" :height="isMobile ? '40px' : '50px'" class="admin_logo" />
      </div>
    </template>
    <template #right>
      <AppNavbarActions class="app-navbar__actions" :is-mobile="isMobile" />
    </template>
  </VaNavbar>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useGlobalStore } from '../../stores/global-store'
import AppNavbarActions from './components/AppNavbarActions.vue'
import VaIconMenuCollapsed from '../icons/VaIconMenuCollapsed.vue'
import IntmainLogo from '../IntmainLogo.vue'
// import { useColors } from 'vuestic-ui'

defineProps({
  isMobile: { type: Boolean, default: false },
})

const GlobalStore = useGlobalStore()
const { isSidebarMinimized } = storeToRefs(GlobalStore)

// const { getColor } = useColors()
const collapseIconColor = computed(() => '#FFFFFF')
</script>

<style lang="scss" scoped>
.va-navbar {
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media screen and (max-width: 768px) {
    .left {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .app-navbar__actions {
      display: flex;
      justify-content: flex-end;
      flex-grow: 1;
    }
  }
}

.admin_logo {
  font-weight: 700;
  font-size: 25px;
  margin-left: 10px;
  color: white;
  text-transform: uppercase;

  @media screen and (max-width: 768px) {
    font-size: 20px;
    text-align: center;
    flex-grow: 1;
  }
}

.MenuCollapsed {
  margin-left: 10px;
  @media screen and (max-width: 768px) {
    position: absolute;
    right: 15px;
  }
}

.left {
  display: flex;
  align-items: center;
  margin-left: 1rem;

  & > * {
    margin-right: 1rem;
  }

  & > *:last-child {
    margin-right: 0;
  }
}

.icon-fade-enter-active,
.icon-fade-leave-active {
  transition: transform 0.5s ease;
}

.icon-fade-enter,
.icon-fade-leave-to {
  transform: scale(0.5);
}
</style>
